import * as React from 'react'

function SvgFunDrawer(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M19.164 17c.462 0 .836.448.836 1s-.374 1-.836 1H4.836C4.374 19 4 18.552 4 18s.374-1 .836-1h14.328zm0-6c.462 0 .836.448.836 1s-.374 1-.836 1H4.836C4.374 13 4 12.552 4 12s.374-1 .836-1h14.328zm0-6c.462 0 .836.448.836 1s-.374 1-.836 1H4.836C4.374 7 4 6.552 4 6s.374-1 .836-1h14.328z" />
    </svg>
  )
}

export default SvgFunDrawer
